import React, { FunctionComponent } from "react"
import { Header } from "../header/Header"
import { Helmet } from "react-helmet"

interface IDefaultProps {
  title: string
}

const Default: FunctionComponent<IDefaultProps> = ({ children, title }) => {
  return (
    <>
      <Helmet
        htmlAttributes={{
          lang: "en",
        }}
      >
        <meta
          name="Googlebot"
          content="all|none, index|noindex, follow|nofollow, notranslate, noydir, noodp, noarchive, snippet|nosnippet, noimageindex, nocache"
        />
        <meta name="Description" content="Dragos Nedelcu personal portfolio" />
        <meta charSet="utf-8" />
        <title>{title}</title>
      </Helmet>
      {children}
    </>
  )
}

export default Default
